import { PlatformWalkthroughModel } from "../interfaces";
import { action } from "easy-peasy";

export const PlatformWalkthrough: PlatformWalkthroughModel = {
  explorerStep: 0,
  setExplorerStep: action((state, payload) => {
    state.explorerStep = payload;
  }),
  publisherStep: 0,
  setPublisherStep: action((state, payload) => {
    state.publisherStep = payload;
  }),
};
